import { getStorageData } from "@/utils/storage";
import {
  default as apiGetCompanyGroups,
  getGroupById as apiGetGroupById,
  deleteGroup as apiDeleteGroup,
  addGroup as apiCreateCompanyGroup,
  updateGroup as apiUpdateGroup,
  getManagers as apiGetCompanyManagers,
  getTrainees as apiGetCompanyTrainees
} from "@api/company/group";

import { getOperational as apiGetOperational } from "@api/company";

const companyGroupStore = {
  namespaced: true,
  state: {
    groups: [],
    group: {},
    managers: [],
    trainees: []
  },
  getters: {
    groups(state) {
      return state.groups;
    },
    group(state) {
      return state.group;
    },
    managers(state) {
      return state.managers;
    },
    trainees(state) {
      return state.trainees;
    }
  },
  mutations: {
    setCompanyGroups(state, payload) {
      state.groups = payload;
    },
    setCompanyGroup(state, payload) {
      state.group = payload;
    },
    setOperational(state, payload) {
      state.operational = { ...state.operational, ...payload };
    },
    setState(state, payload) {
      state[payload.name] = payload.data;
    }
  },
  actions: {
    async createCompanyGroup(_, group) {
      const company = getStorageData("company");

      const { id: companyId } = company;
      group = await apiCreateCompanyGroup(companyId, group);
      return group.data;
    },
    async updateCompanyGroup(_, { groupId, data }) {
      const company = getStorageData("company");
      const { id: companyId } = company;

      await apiUpdateGroup({
        companyId,
        groupId,
        data
      });
    },
    async getCompanyGroups({ commit }) {
      const company = getStorageData("company");

      const { id: companyId } = company;
      const { data: companyGroups } = await apiGetCompanyGroups(companyId);

      commit("setCompanyGroups", companyGroups);
    },
    async getManagersAndTrainees({ commit }) {
      const company = getStorageData("company");

      const { id: companyId } = company;

      const managersAndTrainees = [
        apiGetCompanyManagers(companyId),
        apiGetCompanyTrainees(companyId)
      ];

      const [managers, trainees] = await Promise.all(managersAndTrainees);

      commit("setState", {
        name: "managers",
        data: managers.data
      });
      commit("setState", {
        name: "trainees",
        data: trainees.data
      });
    },
    async getCompanyGroupById({ commit }, groupId) {
      const company = getStorageData("company");

      const { id: companyId } = company;
      const { data: group } = await apiGetGroupById(companyId, groupId);

      commit("setState", {
        name: "group",
        data: group
      });
    },
    async getCompanyOperationalInformation({ commit }) {
      const company = getStorageData("company");

      const { id: companyId } = company;

      const apiOperationalResponse = ["acl", "roles", "rpes"].map(type =>
        apiGetOperational(companyId, type)
      );

      const [acl, roles, rpes] = await Promise.all(apiOperationalResponse);

      commit("setOperational", {
        acl: acl.data,
        roles: roles.data,
        rpes: rpes.data
      });
    },
    async deleteGroup({ state }) {
      const company = getStorageData("company");

      const { id: companyId } = company;

      await apiDeleteGroup(companyId, state.group.id);
    }
  }
};

export default companyGroupStore;
